<div class="container" *ngIf="shareObject.data.type=='attendance-station'">
  <!-- <h1 class="fw-bold fs-4 mb-3 text-center">{{'employee_attendance_title'|translate}}</h1> -->
  <div>
    <div class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 20px);">
      <div>
        <img [src]="shareObject.qrCode" alt="">
        <p *ngIf="shareObject.countdown && shareObject.countdown>=0"
          attr.style="color:{{shareObject.countdown>10?'#393':'#f00'}}" class="text-center">
          {{'code_will_refresh_later'|translate}}: <strong>{{shareObject.countdown}}</strong>
          <i class="text-mute ms-1">{{'seconds'|translate}}</i>
        </p>
      </div>
    </div>
  </div>
</div>
<div class="container" *ngIf="shareObject.data.type=='attendance-faceid-station'">
  <div>
    <div class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 20px);">
      <div>
        <span *ngIf="shareObject.faceId" class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="clickScanIDs()">
          <i class="bi bi-person-video3"></i>
          <span class="ms-2">{{'scan_faceid'|translate}}</span>
        </span>
      </div>
    </div>
  </div>
</div>

<div class="container" *ngIf="shareObject.data.type=='attendance-faceid'">
  <!-- <h1 class="fw-bold fs-4 mb-3 text-center">{{'employee_attendance_title'|translate}}</h1> -->
  <div>
    <div class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 20px);">
      <div>
        <span *ngIf="shareObject.faceId" class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="clickScanID()">
          <i class="bi bi-person-video3"></i>
          <span class="ms-2">{{'scan_faceid'|translate}}</span>
        </span>
      </div>
    </div>
  </div>
</div>

<div class="container" *ngIf="shareObject.data.type=='attendance-qrcode'">
  <!-- <h1 class="fw-bold fs-4 mb-3 text-center">{{'employee_attendance_title'|translate}}</h1> -->
  <div>
    <div class="d-flex justify-content-center align-items-center gap-2" style="height: calc(100vh - 20px);">
      <div>
        <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="clickScanQR()">
          <i class="bi bi-qr-code-scan"></i>
          <span class="ms-2">{{'scan_qr_code'|translate}}</span>
        </span>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center gap-2 mt-3 h-100 w-100 d-none">
      <!-- <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1">
        <i class="bi bi-qr-code"></i>
        <span class="ms-2">{{'qr_code'|translate}}</span>
      </span> -->
      <!-- <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="setupPWA()">
        <i class="bi bi-qr-code-scan"></i>
        <span class="ms-2">{{'setup_attendance_pwa'|translate}}</span>
      </span> -->

      <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="capture()">
        <i class="bi bi-camera"></i>
        <span class="ms-2">{{'get_faceid'|translate}}</span>
      </span>

      <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1" routerLink="/user/employee/attendance/list">
        <i class="bi bi-card-list"></i>
        <span class="ms-2">{{'attendance_list'|translate}}</span>
      </span>
    </div>
  </div>
</div>
<div class="container" *ngIf="shareObject.data.type=='attendance-all-method'">
  <!-- <h1 class="fw-bold fs-4 mb-3 text-center">{{'employee_attendance_title'|translate}}</h1> -->
  <div>
    <div class="d-flex justify-content-center align-items-center gap-2" style="height: calc(100vh - 20px);">
      <div>
        <div class="d-flex gap-2 mb-2">
          <div>
            <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="clickScanQR()">
              <i class="bi bi-qr-code-scan"></i>
              <span class="ms-2">{{'scan_qr_code'|translate}}</span>
            </span>
          </div>
          <div>
            <span *ngIf="shareObject.faceId && !sharedService.isLowTech"
              class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="clickScanID()">
              <i class="bi bi-person-video3"></i>
              <span class="ms-2">{{'scan_faceid'|translate}}</span>
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <!-- back btn -->
          <span class="gap-2 btn btn-sm btn-outline-warning rounded-1" routerLink="/user/profile">
            <i class="bi bi-arrow-left"></i>
            <span class="ms-2">{{'btn_back'|translate}}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center gap-2 mt-3 h-100 w-100 d-none">
      <!-- <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1">
        <i class="bi bi-qr-code"></i>
        <span class="ms-2">{{'qr_code'|translate}}</span>
      </span> -->
      <!-- <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="setupPWA()">
        <i class="bi bi-qr-code-scan"></i>
        <span class="ms-2">{{'setup_attendance_pwa'|translate}}</span>
      </span> -->

      <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1" (click)="capture()">
        <i class="bi bi-camera"></i>
        <span class="ms-2">{{'get_faceid'|translate}}</span>
      </span>

      <span class="d-flex gap-2 btn btn-sm btn-primary rounded-1" routerLink="/user/employee/attendance/list">
        <i class="bi bi-card-list"></i>
        <span class="ms-2">{{'attendance_list'|translate}}</span>
      </span>
    </div>
  </div>
</div>


<div class="p-3" id="attendance-list" *ngIf="shareObject.data.type=='list'">
  <h1 class="fw-bold fs-4 mb-3">{{'employee_attendance_list_title'|translate}}</h1>
  <div>
    <div class="d-flex gap-2 mb-2" id="btns">
      <span class="d-flex gap-2 btn btn-sm btn-outline-warning rounded-1" routerLink="/user/employee/attendance">
        <i class="bi bi-arrow-left"></i>
        <span class="ms-2">{{'btn_back'|translate}}</span>
      </span>
      <span class="d-flex gap-2 btn btn-sm btn-outline-success rounded-1"
        (click)="shareObject.detailColor=!shareObject.detailColor">
        <span class="ms-2">{{'btn_detail_color'|translate}}</span>
      </span>
      <span class="d-flex gap-2 btn btn-sm btn-outline-success rounded-1" (click)="downloadHtml()">
        <span class="ms-2">{{'btn_download_html'|translate}}</span>
      </span>
      <span class="btn btn-sm btn-primary rounded-1" (click)="shareObject.filterBox = true" role="button">
        <i class="bi bi-funnel"></i>
        <span class="ms-2"> {{'btn_filter'|translate}} </span>
      </span>
    </div>
    <!-- search box -->
    <div style="z-index: 1050; width: 600px" class="position-absolute">
      <form *ngIf="shareObject.filterBox===true" [formGroup]="filterForm"
        class="advanced-filters shadow-lg bg-white border rounded p-3 mt-2">
        <div class="row g-2">
          <!-- employee keyword -->
          <div class="col-md-12">
            <label class="form-label fw-bold" for="keyword">{{'filter_keyword'|translate}}</label>
            <input type="text" class="form-control form-control-sm" formControlName="keyword" id="keyword">
          </div>
          <div class="col-md-12">
            <label class="form-label fw-bold" for="group">{{'filter_group'|translate}}</label>
            <select class="form-select form-select-sm" formControlName="employeeGroup" id="group">
              <option value="">{{'filter_group_all'|translate}}</option>
              <option *ngFor="let group of shareObject.employeeGroupList" value="{{group.id}}">{{group.name}}
              </option>
            </select>
          </div>
          <!-- page size -->
          <div class="col-md-4">
            <label class="form-label fw-bold" for="pagesize">{{"page_size"|translate}}</label>
            <select class="form-select form-select-sm" formControlName="limit" id="pagesize">
              <option *ngFor="let size of sharedService.env.pageSize" value="{{size}}">{{size}}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold" for="date">{{'filter_start_date'|translate}}</label>
            <input type="date" class="form-control form-control-sm" formControlName="startDate" id="startDate">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold" for="date">{{'filter_end_date'|translate}}</label>
            <input type="date" class="form-control form-control-sm" formControlName="endDate" id="endDate">
          </div>
          <!-- employee keyword -->
          <div class="col-md-3">
            <label class="form-label fw-bold mb-4" for="btns"></label>
            <div class=" d-flex gap-2" id="btns">
              <button class="btn btn-primary btn-sm rounded-1" (click)="onSearch()">{{'btn_filter'|translate}}</button>
              <button class="btn btn-secondary btn-sm rounded-1"
                (click)="shareObject.filterBox=false">{{'btn_close'|translate}}</button>
              <!-- <button class="btn btn-primary btn-sm rounded-1"
                  (click)="refresh()">{{'btn_clear'|translate}}</button> -->
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- filter result -->
    <div class="d-flex gap-2 mb-3 mt-2">
      <button type="button" *ngIf="shareObject.options.keyword"
        class="btn btn-outline-primary btn-sm rounded-1 position-relative">
        {{shareObject.options.keyword}}
        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
          (click)="filter('keyword', undefined)" role="button">x</span>
      </button>
      <button type="button" *ngIf="shareObject.options.employeeGroup"
        class="btn btn-outline-primary btn-sm rounded-1 position-relative">
        {{shareObject.groupName}}
        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
          (click)="filter('employeeGroup', undefined)" role="button">x</span>
      </button>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-hover bg-white">
        <thead class="thead-dark">
          <tr>
            <th class="fixed-column" scope="col" style="width: 200px;">Nhân viên</th>
            <th *ngFor="let day of shareObject.daysArray" scope="col" class="text-center">{{ day }}</th>
          </tr>
        </thead>
        <tbody *ngIf="shareObject.employees && shareObject.employees.length > 0 && !shareObject.isLoading">
          <tr *ngFor="let employee of shareObject.employees">
            <th class="fixed-column" scope="row">
              <div *ngIf="employee.attendances" class="position-relative">
                <span>{{ employee.profile?.name }}</span>
                <div>
                  <div *ngIf="employee.totalCheckinLate > 0">
                    <span class="text-warning">
                      {{ 'employee_status_checkin' | translate }}
                      {{ 'employee_status_late' | translate }}:
                      {{ employee.totalCheckinLate }}
                    </span>
                  </div>
                  <div *ngIf="employee.totalCheckinEarly > 0">
                    <span class="text-success">
                      {{ 'employee_status_checkin' | translate }}
                      {{ 'employee_status_early' | translate }}:
                      {{ employee.totalCheckinEarly }}
                    </span>
                  </div>
                  <div *ngIf="employee.totalCheckoutLate > 0">
                    <span class="text-success">
                      {{ 'employee_status_checkout' | translate }}
                      {{ 'employee_status_late' | translate }}:
                      {{ employee.totalCheckoutLate }}
                    </span>
                  </div>
                  <div *ngIf="employee.totalCheckoutEarly > 0">
                    <span class="text-warning">
                      {{ 'employee_status_checkout' | translate }}
                      {{ 'employee_status_early' | translate }}:
                      {{ employee.totalCheckoutEarly }}
                    </span>
                  </div>
                  <div *ngIf="employee.totalMiss > 0">
                    <span class="text-danger">
                      {{ 'employee_status_miss' | translate }}:
                      {{ employee.totalMiss }}
                    </span>
                  </div>
                  <div class="report-icon">
                    <a attr.data-title="{{'report'|translate}}" routerLink="/user/employee/attendance/report"
                      target="_blank"
                      [queryParams]="{ employeeId: employee.id, startDate: shareObject.startDate, endDate: shareObject.endDate}">
                      <i class="bi bi-clipboard2-data-fill fs-5 text-primary" role="button"></i>
                    </a>
                  </div>
                </div>
              </div>
            </th>
            <td *ngFor="let day of shareObject.daysArray" attr.class="{{shareObject.detailColor?'detail':''}}">
              <div *ngIf="!employee.attendances[day]">
                <span class="text-secondary"></span>
              </div>
              <div *ngIf="employee.attendances[day]">
                <!-- <div  class="{{employee.attendances[day].length % 2 ==0?'':'bg-danger text-white'}}" *ngFor="let checkpoint of employee.attendances[day]"> -->
                <div class="" *ngFor="let checkpoint of employee.attendances[day]"
                  attr.class="checkpoint-{{checkpoint.type}}-{{checkpoint.status}} fs-7"
                  style="text-shadow: 1px 1px 1px rgba(39, 128, 227, .4);">
                  <div class="{{checkpoint.overtime?'bg-secondary':''}}">

                    <!-- <span>
                    <i class="bi bi-check-circle-fill text-success"></i>
                    <span class="text-success">{{ checkpoint.createdAt | date: 'shortTime' }}</span>
                  </span> -->
                    <span *ngIf="checkpoint.type=='checkin'" class="d-flex justify-content-between align-items-center ">
                      <span class="badge text-bg-success me-1">{{ 'employee_status_checkin' | translate }}</span>
                      <span class="text-success">{{ checkpoint.sheet | date: 'shortTime' }}</span>
                      <span class="text-success">({{ checkpoint.time | date: 'shortTime' }})</span>
                      <i *ngIf="checkpoint.status=='match'" class="fs-5 bi bi-bookmark-check text-primary"
                        attr.data-title=" {{ 'employee_status_match' | translate }}"></i>
                      <i *ngIf="checkpoint.status=='late'" class="fs-5 bi bi-bookmark-star text-warning"
                        attr.data-title=" {{ 'employee_status_late' | translate }}"></i>
                      <i *ngIf="checkpoint.status=='early'" class="fs-5 bi bi-bookmark-heart text-success"
                        attr.data-title=" {{ 'employee_status_early' | translate }}"></i>
                      <i *ngIf="checkpoint.status=='miss'" class="fs-5 bi bi-bookmark-x text-danger"
                        attr.data-title=" {{ 'employee_status_miss' | translate }}"></i>
                    </span>
                    <span *ngIf="checkpoint.type=='checkout'" class="d-flex justify-content-between align-items-center">
                      <span class="badge text-bg-warning me-1">{{ 'employee_status_checkout' | translate }}</span>
                      <span class="text-warning">{{ checkpoint.sheet | date: 'shortTime' }}</span>
                      <span class="text-warning">({{ checkpoint.time | date: 'shortTime' }})</span>
                      <i *ngIf="checkpoint.status=='match'" class="fs-5 bi bi-bookmark-check text-primary"
                        attr.data-title=" {{ 'employee_status_match' | translate }}"></i>
                      <i *ngIf="checkpoint.status=='late'" class="fs-5 bi bi-bookmark-heart text-success"
                        attr.data-title=" {{ 'employee_status_late' | translate }}"></i>
                      <i *ngIf="checkpoint.status=='early'" class="fs-5 bi bi-bookmark-star text-warning"
                        attr.data-title=" {{ 'employee_status_early' | translate }}"></i>
                      <i *ngIf="checkpoint.status=='miss'" class="fs-5 bi bi-bookmark-x text-danger"
                        attr.data-title=" {{ 'employee_status_miss' | translate }}"></i>
                    </span>

                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <caption *ngIf="shareObject.employees && shareObject.employees.length == 0 && !shareObject.isLoading">
          <span class="text-danger fw-bold fs-5">{{'no_data'|translate}}</span>
        </caption>
        <caption *ngIf="shareObject.isLoading">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </caption>
      </table>
    </div>
  </div>
</div>
<!-- history -->
<div class="p-3" id="attendance-list" *ngIf="shareObject.data.type=='history'">
  <h1 class="fw-bold fs-4 mb-3">{{'employee_attendance_history_title'|translate}}</h1>
  <div *ngIf="!shareObject.isLoading">
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-hover bg-white">
        <thead class="thead-dark">
          <tr>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'attendance_employee'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'attendance_time'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'attendance_type'|translate}}</th>
            <!-- <th class="fixed-column" scope="col" style="width: 200px;">{{'attendance_station'|translate}}</th> -->
          </tr>
        </thead>
        <tbody
          *ngIf="shareObject.attendanceRecords && shareObject.attendanceRecords.length > 0 && !shareObject.isLoading">
          <tr *ngFor="let employee of shareObject.attendanceRecords">
            <td>
              <span class="fw-bold me-2">{{ employee.user.profile?.name }}</span>
              <span class="form-text">({{employee.user.email}})</span>
            </td>
            <td>{{ employee.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ employee.data.type }}</td>
            <!-- <td>{{ employee.data.station?. }}</td> -->
          </tr>
        </tbody>
        <caption
          *ngIf="shareObject.attendanceRecords && shareObject.attendanceRecords.length == 0 && !shareObject.isLoading">
          <span class="text-danger fw-bold fs-5">{{'no_data'|translate}}</span>
        </caption>
        <caption *ngIf="shareObject.isLoading">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </caption>
      </table>
    </div>
  </div>
  <div *ngIf="shareObject.isLoading">
    <div class="d-flex justify-content-center align-items-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>

<div class="printArea" *ngIf="shareObject.data.type=='report'">
  <div>
    <!-- <h1 class="fw-bold fs-4 mb-2">{{'employee_attendance_report_title'|translate}}</h1> -->
    <h3 *ngIf="shareObject.options.user" class="mb-2">
      <span>{{'attendance_report_of_employee'|translate}}: {{shareObject?.employees[0]?.profile?.name}}</span>
    </h3>
    <!-- từ ngày đến ngày -->
    <div class="d-flex gap-2 mb-3">
      <span>{{'from_date'|translate}}: {{shareObject.daysArray[0]}}</span>
      <span class="ms-3">{{'to_date'|translate}}: {{shareObject.daysArray[shareObject.daysArray.length -1]}}</span>
    </div>
    <div class="d-flex gap-2 hide-on-print mb-3">
      <span class="btn btn-sm btn-primary rounded-1" (click)="sharedService.modalControl('#modal')" role="button">
        <i class="bi bi-print"></i>
        <span class="ms-2"> {{'btn_change'|translate}} </span>
      </span>
      <span class="btn btn-sm btn-primary rounded-1" role="button">
        <i class="bi bi-print"></i>
        <span class="ms-2" (click)="window.print()"> {{'btn_print'|translate}} </span>
      </span>
      <!-- <div class="d-flex gap-2 mb-2">
        <span class="d-flex gap-2 btn btn-sm btn-outline-warning rounded-1" (click)="sharedService.back()">
          <i class="bi bi-arrow-left"></i>
          <span class="ms-2">{{'btn_back'|translate}}</span>
        </span>
        <span class="d-flex gap-2 btn btn-sm btn-outline-success rounded-1"
          (click)="shareObject.detailColor=!shareObject.detailColor">
          <span class="ms-2">{{'btn_detail'|translate}}</span>
        </span>
        <span class="btn btn-sm btn-primary rounded-1" (click)="shareObject.filterBox = true" role="button">
          <i class="bi bi-funnel"></i>
          <span class="ms-2"> {{'btn_filter'|translate}} </span>
        </span>
      </div> -->
    </div>
    <div *ngIf="shareObject.options.employeeGroup">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="fixed-column" scope="col" style="width: 200px;">Nhân viên</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'total_cheackin'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'cheackin_early'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'cheackin_late'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'cheackin_match'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'cheackin_miss'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'total_checkout'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'checkout_early'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'checkout_late'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'checkout_match'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'checkout_miss'|translate}}</th>
            <th class="fixed-column" scope="col" style="width: 200px;">{{'total_miss'|translate}}</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let employee of shareObject.employees">
            <td>{{ employee.profile?.name }}</td>
            <td>
              <span class="fw-bold">{{employee.totalCheckin}}</span>
            </td>
            <td>
              <span class="text-primary fw-bold">{{employee.totalCheckinEarly}}</span>
            </td>
            <td>
              <span class="text-warning fw-bold">{{employee.totalCheckinLate}}</span>
            </td>
            <td>
              <span class="fw-bold">{{employee.totalCheckinMatch}}</span>
            </td>
            <td>
              <span class="text-danger fw-bold">{{employee.totalCheckinMiss}}</span>
            </td>
            <td>
              <span class="fw-bold">{{employee.totalCheckout}}</span>
            </td>
            <td>
              <span class="text-warning fw-bold">{{employee.totalCheckoutEarly}}</span>
            </td>
            <td>
              <span class="text-primary fw-bold">{{employee.totalCheckoutLate}}</span>
            </td>
            <td>
              <span class="fw-bold">{{employee.totalCheckoutMatch}}</span>
            </td>
            <td>
              <span class="text-danger fw-bold">{{employee.totalCheckoutMiss}}</span>
            </td>
            <td>
              <span class="text-danger fw-bold">{{employee.totalMiss}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="shareObject.options.user">
      <div class="mb-3">
        <canvas id="pieChart" width="397" height="200"></canvas>
      </div>
      <div>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th class="fixed-column" scope="col">{{'date'|translate}}</th>
              <th scope="col">{{'cheackin_early'|translate}}</th>
              <th scope="col">{{'cheackin_match'|translate}}</th>
              <th scope="col">{{'cheackin_late'|translate}}</th>
              <th scope="col">{{'cheackin_miss'|translate}}</th>
              <th scope="col">{{'checkout_early'|translate}}</th>
              <th scope="col">{{'checkout_match'|translate}}</th>
              <th scope="col">{{'checkout_late'|translate}}</th>
              <th scope="col">{{'checkout_miss'|translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of shareObject.attendanceRecords">
              <td class="fixed-column">{{ item?.date}}</td>
              <td><span class="fw-bold">{{item?.checkin_early}}</span></td>
              <td><span class=" text-primary fw-bold">{{item?.checkin_match}}</span></td>
              <td><span class="text-warning fw-bold">{{item?.checkin_late}}</span></td>
              <td> <span class="text-danger fw-bold">{{item?.checkin_miss}}</span></td>
              <td> <span class="fw-bold">{{item?.checkout_early}}</span> </td>
              <td><span class=" text-primary fw-bold">{{item?.checkout_match}}</span></td>
              <td><span class="text-warning fw-bold">{{item?.checkout_late}}</span></td>
              <td><span class="text-danger fw-bold">{{item?.checkout_miss}}</span></td>
            </tr>
            <tr>
              <td>{{'total'|translate}}</td>
              <td><span class="fw-bold">{{shareObject?.userAttendance?.totalCheckinEarly}}</span></td>
              <td><span class=" text-primary fw-bold">{{shareObject?.userAttendance?.totalCheckinMatch}}</span></td>
              <td><span class="text-warning fw-bold">{{shareObject?.userAttendance?.totalCheckinLate}}</span></td>
              <td> <span class="text-danger fw-bold">{{shareObject?.userAttendance?.totalCheckinMiss}}</span></td>
              <td> <span class="fw-bold">{{shareObject?.userAttendance?.totalCheckoutEarly}}</span></td>
              <td><span class=" text-primary fw-bold">{{shareObject?.userAttendance?.totalCheckoutMatch}}</span></td>
              <td><span class="text-warning fw-bold">{{shareObject?.userAttendance?.totalCheckoutLate}}</span></td>
              <td><span class="text-danger fw-bold">{{shareObject?.userAttendance?.totalCheckoutMiss}}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div *ngIf="shareObject.isLoading">
    <div class="d-flex justify-content-center align-items-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>
<!-- modal -->
<div class="modal fade" id="modal" tabindex="-1" aria-labelledby="filterModal" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="filterModal">{{'call_report_detail'|translate}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row">

          <form action="" [formGroup]="filterForm" class="" (ngSubmit)="onSearch()">
            <div class="mb-3">
              <label class="form-label fw-bold" for="date">{{'filter_start_date'|translate}}</label>
              <input type="date" class="form-control form-control-sm" formControlName="startDate" id="startDate">
            </div>
            <div class="mb-3">
              <label class="form-label fw-bold" for="date">{{'filter_end_date'|translate}}</label>
              <input type="date" class="form-control form-control-sm" formControlName="endDate" id="endDate">
            </div>
            <button class="btn btn-sm btn-primary">
              <i class="fa-solid fa-magnifying-glass"></i>
              {{'filter'|translate}}
            </button>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{'btn_close'|translate}}</button>
      </div>
    </div>

  </div>
</div>